import type { FC } from 'react';
import React, { useCallback } from 'react';
import cx from 'classnames';
import { MDText } from 'i18n-react';

import { MultiSelect } from '@motorway/motorway-storybook-cra';

import { APP_THEME } from 'Utilities/consts';

import allTexts from '../../VehicleListV2.texts.json';
import { useMakeModelFilter } from '../hooks/useMakeModelFilter';

import styles from './AllFiltersContent/AllFiltersContent.module.scss';

const LocalT = new MDText(allTexts);

interface MakeModelSectionProps {
	setValue: (arg: { id: string; value: unknown }) => void;
}

export const MakeModelSection: FC<MakeModelSectionProps> = ({ setValue }) => {
	const handleCommit = useCallback(
		(makes: string[], models: number[]) => {
			setValue({ id: 'make', value: makes });
			setValue({ id: 'model', value: models });
		},
		[setValue],
	);

	const {
		formattedMakes,
		formattedModels,
		handleMakeChange,
		handleModelChange,
		isModelDisabled,
		makeOptionsChangedCount,
		makeValues,
		modelOptionsChangedCount,
		modelValues,
	} = useMakeModelFilter({ autoCommit: true, onCommit: handleCommit });

	return (
		<div className={styles.makeModelSection}>
			<div className={styles.makeModelField}>
				<span className={styles.fieldLabel}>{`${LocalT.translate('filterOptions.make')}`}</span>
				<MultiSelect
					key={`make-${makeOptionsChangedCount}`}
					searchBar
					className={cx('mw-input-select mw-input-multiselect mw-input-multiselect-dark', styles.multiSelect)}
					id="all-filters-multiselect-make"
					inputProps={{}}
					onChange={handleMakeChange}
					options={formattedMakes}
					placeholder={`${LocalT.translate('filterOptions.anyMake')}`}
					theme={APP_THEME}
					value={makeValues}
				/>
			</div>
			<div className={styles.makeModelField}>
				<span className={styles.fieldLabel}>{`${LocalT.translate('filterOptions.model')}`}</span>
				<MultiSelect
					key={modelOptionsChangedCount}
					searchBar
					className={cx('mw-input-select mw-input-multiselect mw-input-multiselect-dark', styles.multiSelect)}
					id="all-filters-multiselect-model"
					inputProps={{ disabled: isModelDisabled }}
					onChange={handleModelChange}
					options={formattedModels}
					placeholder={`${LocalT.translate('filterOptions.anyModel')}`}
					theme={APP_THEME}
					value={modelValues}
				/>
			</div>
		</div>
	);
};
